import type { Directive, DirectiveBinding } from 'vue'

interface ScrollOptions {
  behavior?: 'auto' | 'smooth'
  block?: 'start' | 'center' | 'end' | 'nearest'
  inline?: 'start' | 'center' | 'end' | 'nearest'
}

const defaultArgs: ScrollOptions = {
  behavior: 'auto',
  block: 'start',
  inline: 'start',
}

const scrollIntoItem = (
  el: HTMLElement,
  options: boolean | ScrollOptions
): void => {
  const effectiveArgs: boolean | ScrollOptions =
    typeof options === 'boolean'
      ? true
      : {
          ...defaultArgs,
          ...options,
        }
  el.scrollIntoView(effectiveArgs)
}

const scrollDirective: Directive = {
  mounted(
    el: HTMLElement,
    { value: options }: DirectiveBinding<ScrollOptions | boolean>
  ) {
    if (options) {
      scrollIntoItem(el, options)
    }
  },
  updated(
    el: HTMLElement,
    { value: options, oldValue }: DirectiveBinding<ScrollOptions | boolean>
  ) {
    if (options !== oldValue && options) {
      scrollIntoItem(el, options)
    }
  },
}

export default scrollDirective
